import { useEffect, useState } from 'react';
import * as bi from 'react-bootstrap-icons';
import { MessagePoint } from '..';
import { ModalCalendar, SpoilerCard } from 'shared/components';
import { Flex, Input, Message, Select } from 'components';
import { isBirthDateValid, isNameValid } from './helpers';
import { ICommonInput } from '../../types';
import { ClientPassengerGender, IClientPassengerFull } from '@bustickus/models-client';
import { dateFormat } from 'common/helpers';

interface IProps {
  open: boolean;
  onOpen: () => void;
  onChange: (data: ICommonInput | null) => void;
  initital?: IClientPassengerFull | null;
}

function CommonCard(props: IProps) {
  const [name, setName] = useState<string>(props.initital?.name ?? '');
  const [birthDate, setBirthDate] = useState<Date | null>(props.initital?.birthDate != null ? new Date(props.initital.birthDate) : null);
  const [gender, setGender] = useState<ClientPassengerGender>(props.initital?.gender ?? 'male');

  const [nameTouched, setNameTouched] = useState<boolean>(false);
  const [birthDateTouched, setbirthDateTouched] = useState<boolean>(false);

  const [birthDateModal, setBirthDateModal] = useState<boolean>(false);

  useEffect(() => {
    handleDataChange(name, birthDate, gender);
  }, []);

  const handleNameChange = (value: string) => {
    setName(value);

    if (!nameTouched) {
      setNameTouched(true);
    }

    handleDataChange(value, birthDate, gender);
  };

  const handleBirthDateChange = (value: Date) => {
    setBirthDate(value);

    if (!birthDateTouched) {
      setbirthDateTouched(true);
    }

    if (birthDateModal) {
      setBirthDateModal(false);
    }

    handleDataChange(name, value, gender);
  };

  const handleGenderChange = (value: string) => {
    if (value === 'male' || value === 'female') {
      setGender(value);
      handleDataChange(name, birthDate, value);
    }
  };

  const handleDataChange = (name: string, birthDate: Date | null, gender: ClientPassengerGender) => {
    if (birthDate != null && isNameValid(name) && isBirthDateValid(birthDate)) {
      props.onChange({ name: name, birthDate: birthDate, gender: gender });
    } else {
      props.onChange(null);
    }
  };

  const nameError = !isNameValid(name);
  const birthDateError = !isBirthDateValid(birthDate);
  const inputError = nameError || birthDateError;

  return (
    <SpoilerCard
      open={props.open}
      onOpenClick={props.onOpen}
      title='Основные данные *'
    >
      {birthDateModal && (
        <ModalCalendar
          date={birthDate ?? new Date(2005, 0, 1)}
          onClose={() => setBirthDateModal(false)}
          onSelect={handleBirthDateChange}
        />
      )}

      <Flex
        direction='column'
        gap={10}
      >
        <Flex
          direction='column'
          gap={5}
        >
          <Input
            type='text'
            label='ФИО пассажира'
            placeholder='Иванов Иван Иванович'
            icon={<bi.Person />}
            value={name}
            onChange={handleNameChange}
            error={nameTouched && nameError}
          />

          <Input
            type='text'
            label='Дата рождения'
            placeholder='Нажмите для выбора'
            readonly
            icon={<bi.Calendar />}
            value={birthDate != null ? dateFormat(birthDate, 'DD MMMM YYYY').datetime : ''}
            error={birthDateTouched && birthDateError}
            onClick={() => setBirthDateModal(true)}
          />

          <Select
            label='Пол пассажира'
            value={gender}
            onChange={handleGenderChange}
            icon={gender == 'male' ? <bi.GenderMale /> : <bi.GenderFemale />}
          >
            <option value='male'>Мужской</option>
            <option value='female'>Женский</option>
          </Select>
        </Flex>

        {inputError && (
          <Message type='error'>
            <Flex
              direction='column'
              gap={5}
            >
              {nameError && <MessagePoint type='error'>Имя пассажира заполнено неверно!</MessagePoint>}
              {birthDateError && <MessagePoint type='error'>Дата рождения пассажира заполнено неверно!</MessagePoint>}
            </Flex>
          </Message>
        )}
        {!inputError && (
          <Message type='success'>
            <MessagePoint type='success'>
              <b>Отлично!</b> Данные выглядят корректно
            </MessagePoint>
          </Message>
        )}
      </Flex>
    </SpoilerCard>
  );
}

export default CommonCard;
